import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { useEligibility } from "@/contexts/EligibilityContext";
import { useEffect, useState } from "react";

const AssessmentCategories = () => {
  const { getLatestAssessment } = useEligibility();
  const [assessment, setAssessment] = useState<any>(null);

  useEffect(() => {
    const fetchAssessment = async () => {
      const data = await getLatestAssessment();
      setAssessment(data);
    };
    fetchAssessment();
  }, [getLatestAssessment]);

  if (!assessment?.results?.criteria) {
    return null;
  }

  const categories = [
    { key: 'education', label: 'Education' },
    { key: 'experience', label: 'Experience' },
    { key: 'skills', label: 'Skills' },
    { key: 'language', label: 'Language' },
    { key: 'achievements', label: 'Achievements' }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Assessment Categories</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-6">
          {categories.map(({ key, label }) => (
            <div key={key} className="space-y-2">
              <div className="flex justify-between text-sm">
                <span>{label}</span>
                <span className="text-muted-foreground">
                  {assessment.results.criteria[key]}%
                </span>
              </div>
              <Progress value={assessment.results.criteria[key]} className="h-2" />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AssessmentCategories;